import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import {
  FormControl,
  FormGroup,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { FileInput } from "src/app/models/support";

@Component({
  selector: "phone-ticket",
  templateUrl: "./phone-ticket.component.html",
  styleUrls: ["./phone-ticket.component.scss"],
})
export class PhoneTicketComponent implements OnInit, OnChanges {
  @Input() category: string;
  @Input() form: FormGroup;
  @Input() isVisible: boolean = false;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.category) {
      if (this.isVisible) this.initiateForm();
    }
  }
  initiateForm() {
    this.form.addControl(
      "personalPhoto",
      new FormControl(null, [Validators.required])
    );
    this.form.addControl(
      "passport",
      new FormControl("", [Validators.required])
    );
    this.form.addControl(
      "newPhoneNumber",
      new FormControl("", [Validators.required,Validators.pattern(/^\+?[0-9٠-٩][0-9٠-٩]{7,15}$/
)])
    );
    this.form.addControl("message", new FormControl(""));
  }
  ngOnInit(): void {}
  onFileSelect(file:FileInput, name: string) {
    this.form.get(name).setValue({
      name: file.file.name,
      content: file.base64,
    });
  }

  onFileRemove(name: string) {
    this.form.get(name).reset();
  }

  markAsTouched(name: string) {
    this.form.get(name).markAsTouched();
  }

  get personalPhoto() {
    return this.form.get("personalPhoto");
  }
  get newPhoneNumber() {
    return this.form.get("newPhoneNumber");
  }
  get passport() {
    return this.form.get("passport");
  }
}
